// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"IGZqsWPu","ButtonSkeleton":"aonHMpWg","IconPlaceholder":"Un1dCRMn","Error":"xiG78fj6"};